<script>
import options from './PersonalFundraisingMobilePayOverlay.options'
export default options
</script>

<template>
  <div class="kb-overlay-styles__content-wrapper">
    <article class="kb-personal-fundraising-mobilepay-overlay kb-optimizely-forms kb-fundraise-form">
      <header class="kb-personal-fundraising-mobilepay-overlay__header">
        <div class="kb-personal-fundraising-mobilepay-overlay__icon" aria-hidden="true">
          <svg width="24" height="24" viewBox="18 8 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M27.41 33a2.115 2.115 0 0 1-1.954-1.305l-7.295-17.61a2.112 2.112 0 0 1 1.143-2.76l7.64-3.164a2.111 2.111 0 0 1 2.76 1.143l7.295 17.61a2.112 2.112 0 0 1-1.143 2.76l-7.64 3.165c-.256.106-.53.16-.806.161Zm.343-23.864a.973.973 0 0 0-.373.075l-7.641 3.165a.975.975 0 0 0-.527 1.273l7.295 17.612a.976.976 0 0 0 1.273.528l7.641-3.167a.975.975 0 0 0 .527-1.274l-7.295-17.61a.976.976 0 0 0-.9-.602Z" fill="#5A78FF"/>
            <path style="mix-blend-mode:multiply" opacity=".7" d="m30.186 10.465-1.051.435 2.888 6.973 1.05-.435-2.887-6.973Z" fill="url(#mp-overlay-a)"/>
            <path style="mix-blend-mode:multiply" opacity=".7" d="m35.463 26.179 1.05-.435-3.27-7.893-1.05.435 3.27 7.893Z" fill="url(#mp-overlay-b)"/>
            <path d="M34.136 20.947c-2.185.906-4.01 2.155-5.204 3.66l-3.08-7.438a13.006 13.006 0 0 1 5.204-3.661c2.186-.906 4.393-1.345 6.269-1.09l3.08 7.44a13.002 13.002 0 0 0-6.269 1.089Z" fill="#5A78FF"/>
            <g style="mix-blend-mode:multiply" opacity=".4">
              <path opacity=".9" d="M34.136 20.947c-2.185.906-4.01 2.155-5.204 3.66l-3.08-7.438a13.006 13.006 0 0 1 5.204-3.661c2.186-.906 4.393-1.345 6.269-1.09l3.08 7.44a13.002 13.002 0 0 0-6.269 1.089Z" fill="url(#mp-overlay-c)"/>
              <path opacity=".7" d="M34.136 20.947c-2.185.906-4.01 2.155-5.204 3.66l-3.08-7.438a13.006 13.006 0 0 1 5.204-3.661c2.186-.906 4.393-1.345 6.269-1.09l3.08 7.44a13.002 13.002 0 0 0-6.269 1.089Z" fill="url(#mp-overlay-d)"/>
            </g>
            <path d="M35.14 23.215c-2.365 0-4.53.457-6.209 1.39v-7.522a13.007 13.007 0 0 1 6.21-1.39c2.364 0 4.572.439 6.207 1.392v7.521a13.002 13.002 0 0 0-6.208-1.391Z" fill="#5A78FF"/>
            <defs>
              <linearGradient id="mp-overlay-a" x1="31.842" y1="15.988" x2="31.371" y2="10.486" gradientUnits="userSpaceOnUse">
                <stop stop-color="#504678"/>
                <stop offset=".302" stop-color="#504678" stop-opacity=".616"/>
                <stop offset=".608" stop-color="#504678" stop-opacity=".283"/>
                <stop offset=".852" stop-color="#504678" stop-opacity=".076"/>
                <stop offset="1" stop-color="#504678" stop-opacity="0"/>
              </linearGradient>
              <linearGradient id="mp-overlay-b" x1="33.517" y1="19.957" x2="33.812" y2="26.122" gradientUnits="userSpaceOnUse">
                <stop stop-color="#504678"/>
                <stop offset=".302" stop-color="#504678" stop-opacity=".616"/>
                <stop offset=".608" stop-color="#504678" stop-opacity=".283"/>
                <stop offset=".852" stop-color="#504678" stop-opacity=".076"/>
                <stop offset="1" stop-color="#504678" stop-opacity="0"/>
              </linearGradient>
              <linearGradient id="mp-overlay-c" x1="27.846" y1="20.481" x2="33.618" y2="16.546" gradientUnits="userSpaceOnUse">
                <stop stop-color="#504678"/>
                <stop offset=".179" stop-color="#504678" stop-opacity=".872"/>
                <stop offset=".526" stop-color="#504678" stop-opacity=".536"/>
                <stop offset="1" stop-color="#504678" stop-opacity="0"/>
              </linearGradient>
              <linearGradient id="mp-overlay-d" x1="32.798" y1="16.634" x2="32.542" y2="14.587" gradientUnits="userSpaceOnUse">
                <stop stop-color="#504678"/>
                <stop offset=".643" stop-color="#504678" stop-opacity=".332"/>
                <stop offset="1" stop-color="#504678" stop-opacity="0"/>
              </linearGradient>
            </defs>
          </svg>
        </div>
        <h2 class="kb-stafet-step__step-section-title kb-personal-fundraising-mobilepay-overlay__title">
          {{ getLabel('personalGreetingTitle') }}
        </h2>
      </header>

      <section class="kb-stafet-step kb-stafet-donation-flow__step">
        <div v-if="fieldVisibility.showIntroText" class="kb-stafet-step__texts-wrapper">
          <p class="kb-stafet-step__texts-description">
            {{ getLabel('introText') }}
          </p>
        </div>

        <div v-if="showDonationAmountSection" class="kb-personal-fundraising-mobilepay-overlay__amount">
          <p class="kb-fundraise-form__header">
            <span class="kb-fundraise-form__header--span-required">
              {{ getLabel('donationAmountText') }}
            </span>
          </p>
          <DonationAmountPicker
            v-if="showDonationAmountSelector || showCustomAmountOnly"
            :donationAmounts="donationAmounts"
            :minimumAmount="1"
            :customAmountOnly="showCustomAmountOnly"
            :onAmountChangeCallback="setDonationAmount"
            :initialValue="initialDonationAmount"
            :customDonationButtonLabel="getLabel('customDonationAmountTitle')"
            :displayInputError="showAmountError"
            :errorMessage="getLabel('donationAmountErrorLabel') || 'Vælg et beløb'"
          />
        </div>

        <div v-if="fieldVisibility.showAnonymousOrPersonalDonation" class="kb-personal-fundraising-mobilepay-overlay__identity">
          <p class="kb-personal-fundraising-mobilepay-overlay__identity-title">
            {{ getLabel('anonymousOrPersonalDonationLabel') }}
          </p>

          <div class="kb-fundraise-form__radio">
            <label class="kb-fundraise-form__radio__input">
              <input
                type="radio"
                name="mobilepay-donation-identity"
                value="0"
                v-model="anonymousDonation"
                class="FormChoice__Input FormChoice__Input--Radio"
              />
              {{ getLabel('namedDonationTypeText') }}
            </label>
            <label class="kb-fundraise-form__radio__input">
              <input
                type="radio"
                name="mobilepay-donation-identity"
                value="1"
                v-model="anonymousDonation"
                class="FormChoice__Input FormChoice__Input--Radio"
              />
              {{ getLabel('anonymousDonationTypeText') }}
            </label>
          </div>
        </div>

        <div class="kb-personal-fundraising-mobilepay-overlay__form-fields">
          <FormInputTextField
            v-model="firstName"
            fieldName="mobilepay-first-name"
            autocomplete="given-name"
            isRequired
            :label="getLabel('firstNameLabel')"
            :isValidationError="showFirstNameError"
            :errorMessageLabel="getLabel('firstNameErrorLabel') || 'Indtast dit fornavn'"
          />

          <FormInputTextField
            v-model="lastName"
            fieldName="mobilepay-last-name"
            autocomplete="family-name"
            isRequired
            :label="getLabel('lastNameLabel')"
            :isValidationError="showLastNameError"
            :errorMessageLabel="getLabel('lastNameErrorLabel') || 'Indtast dit efternavn'"
          />

          <FormInputTextarea
            v-if="showPersonalGreetingField"
            v-model="personalGreeting"
            fieldName="mobilepay-greeting"
            :label="getLabel('personalGreetingText')"
            :placeholder="getLabel('placeholderGreeting')"
          />

          <FormInputTextField
            v-model="phone"
            fieldName="mobilepay-phone"
            autocomplete="tel"
            type="tel"
            isRequired
            :label="getLabel('phoneLabel')"
            :isValidationError="showPhoneError"
            :errorMessageLabel="getLabel('phoneErrorLabel') || 'Indtast et gyldigt telefonnummer'"
          />

          <div
            v-if="fieldVisibility.showTaxDeduction"
            class="kb-sign-up-form__kb-form__checkbox-container"
          >
            <input
              id="mobilepay-tax-deduction"
              v-model="taxDeduction"
              type="checkbox"
              name="mobilepay-tax-deduction"
              class="kb-sign-up-form__kb-form__radio-input"
            />
            <label for="mobilepay-tax-deduction" class="kb-sign-up-form__kb-form__radio-label">
              {{ getLabel('taxDeductionLabel') }}
            </label>
            <TooltipComponent :tooltipText="getLabel('taxDeductionTooltipLabel')" />
          </div>

          <FormInputTextField
            v-if="showCpr"
            v-model="cprNumber"
            fieldName="mobilepay-cpr"
            autocomplete="off"
            isRequired
            :label="getLabel('cprLabel')"
            :isValidationError="showCprError"
            :errorMessageLabel="getLabel('cprErrorLabel') || 'Indtast et gyldigt CPR-nummer'"
          />
        </div>

        <p
          v-if="submitError"
          class="kb-personal-fundraising-mobilepay-overlay__submit-error"
          role="alert"
        >
          {{ submitError }}
        </p>

        <button
          type="button"
          class="kb-button kb-personal-fundraising-mobilepay-overlay__cta"
          :disabled="isSubmitting"
          @click="goToMobilePay"
        >
          {{ getLabel('ctaButtonText') }}
        </button>
      </section>

      <template v-if="isSubmitting">
        <div class="kb-spinner-overlay">
          <div
            class="kb-spinner-overlay__spinner kb-spinner-overlay__spinner--sticky"
          ></div>
        </div>
      </template>
    </article>
  </div>
</template>
